module.exports = __webpack_public_path__ + "img/image4.103854dc.png";